import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UsersService } from '../../generated/users/api/users.service';
import {
  ApiUsersLoginPost200Response,
  ApiUsersLoginPostRequest,
  ApiUsersMeGet200Response,
} from '../../generated/users/model/models';
import { appApiBase } from '../config/api-base';

type UsersDeleteResponse = {
  status: string;
  messages?: string[];
  user?: Record<string, never>;
};

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  private readonly jsonMime = 'application/json';
  private readonly apiBase = appApiBase();
  private readonly usersService = inject(UsersService);
  private readonly http = inject(HttpClient);

  login(email: string, password: string): Observable<ApiUsersLoginPost200Response> {
    const body: ApiUsersLoginPostRequest = { email, password };
    return this.usersService.apiUsersLoginPost(this.jsonMime, this.jsonMime, body);
  }

  me(token: string): Observable<ApiUsersMeGet200Response> {
    return this.usersService.apiUsersMeGet(this.jsonMime, `Bearer ${token}`, this.jsonMime);
  }

  deleteMe(token: string): Observable<UsersDeleteResponse> {
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.http.delete<UsersDeleteResponse>(`${this.apiBase}/api/users/me.json`, { headers });
  }
}
